import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getCreditInvoices } from '../../../api/invoice/get-credit-invoices'

/* Initial state of the slice */
const initialState = {
  isFetchingCreditInvoices: false,
  creditInvoices: [],
  fetchCreditInvoicesError: null,
}

/* Handler for making service call to fetch inventory items */
export const fetchCreditInvoices = createAsyncThunk(
  'creditInvoice/fetchCreditInvoices',
  async (args, { rejectWithValue }) => {
    try {
      const response = await getCreditInvoices()
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const creditInvoiceSlice = createSlice({
  name: 'creditInvoice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCreditInvoices.pending, (state) => {
        state.isFetchingCreditInvoices = true
        state.creditInvoices = []
        state.fetchCreditInvoicesError = null
      })
      .addCase(fetchCreditInvoices.fulfilled, (state, action) => {
        state.isFetchingCreditInvoices = false
        state.creditInvoices = action.payload
      })
      .addCase(fetchCreditInvoices.rejected, (state, action) => {
        state.isFetchingCreditInvoices = false
        state.fetchCreditInvoicesError = action.payload
      })
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export default creditInvoiceSlice.reducer
